module.exports = __webpack_public_path__ + "img/Diagnostic.9248c6d0.svg";